/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TransfersScheduleVersionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_STATE_ENTITY_NAME = 'ixf.hours.v1.TransfersScheduleVersion';
export const ixfHoursV1TransfersScheduleVersionStateEntity = new schema.Entity<IxfHoursV1TransfersScheduleVersionState>(IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_STATE_ENTITY_NAME, {}, { idAttribute: 'transfersScheduleVersionId' });

